import { render, staticRenderFns } from "./ZohoSubscription.vue?vue&type=template&id=20d5e974&scoped=true"
import script from "./ZohoSubscription.vue?vue&type=script&lang=js"
export * from "./ZohoSubscription.vue?vue&type=script&lang=js"
import style0 from "./ZohoSubscription.vue?vue&type=style&index=0&id=20d5e974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5e974",
  null
  
)

export default component.exports